import React from 'react';

import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { IForBankFormSubSections } from 'components/BusinessToolForm/Sections/forBankSections';

import { CompanyOverview } from './CompanyOverview';
import { FinancialInformationOverview } from './FinancialInformationOverview';
import { FundingNeedsOverview } from './FundingNeedsOverview';
import { MarketOverview } from './MarketOverview';
import { ProjectOverview } from './ProjectOverview';

const SUB_SECTIONS: IForBankFormSubSections = {
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.COMPANY]: CompanyOverview,
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.PROJECT]: ProjectOverview,
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.MARKET_CUSTOMERS]: MarketOverview,
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.FINANCIAL_INFO]: FinancialInformationOverview,
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.FUNDING_NEEDS]: FundingNeedsOverview,
};

export const Overview: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
